/* @flow */
import React from 'react';

import TBody from 'components/UIKit/Table/TBody';
import ProjectsRow from './ProjectsRow';

type ProjectsRowsProps = {
  children: any,
  router: Object,
}

export default function ProjectsRows({
  children,
  router,
  projectRoles
}: ProjectsRowsProps): React.Element {
  return (
    TBody({
      children: children.map(project => (
        <ProjectsRow key={ project.project_id } router={ router } projectRoles={projectRoles}>
          {project}
        </ProjectsRow>
      ))
    })
  );
}
